/*
 * TODO: Team to discuss how to clean up config
 * current issue: many configurations are constant, there's little reason to wrap a component in a HOC just to pass constant values
 * working solution: migrate constant configurations into the constants domain and only keep the changing configurations as a `useConfig` hook instead of this
 */

import omit from 'lodash/omit';
import React, {Component} from 'react';
import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';

import Config from './index';

/**
 * WithConfig is a higher order component that provides access to the config.
 * @deprecated Use the {@link module:hooks/config} object instead.
 * @param {React.ReactNode} EnhancedComponent
 * @return {WithConfig}
 *
 * @memberof  module:hooks/config
 */
export default (EnhancedComponent) => {
    /**
     * @class WithConfig
     * @property {Config} config - The config object properties that get passed to a component as props.
     */
    return class WithConfig extends Component {
        constructor(props) {
            super(props);

            const CURRENT_YEAR = new Date().getUTCFullYear();

            this._isStateful = !isUndefined(
                EnhancedComponent?.prototype?.render
            );
            this._months = [
                {label: 'January', value: '1'},
                {label: 'February', value: '2'},
                {label: 'March', value: '3'},
                {label: 'April', value: '4'},
                {label: 'May', value: '5'},
                {label: 'June', value: '6'},
                {label: 'July', value: '7'},
                {label: 'August', value: '8'},
                {label: 'September', value: '9'},
                {label: 'October', value: '10'},
                {label: 'November', value: '11'},
                {label: 'December', value: '12'},
            ];
            this._years = [];
            this._ratesTypes = [
                {label: 'All Rates', value: 'all'},
                {label: 'Daily', value: 'transient'},
                {label: 'Monthly', value: 'monthly'},
            ];
            let startYear = 2012;
            let year;

            for (startYear; startYear <= CURRENT_YEAR; startYear++) {
                year = startYear.toString();

                this._years.push({
                    label: year,
                    value: year,
                });
            }
        }

        _setValues = (opts) => {
            Config.set(opts);
            this.forceUpdate();
        };

        getWrappedInstance() {
            if (isFunction(this._wrappedInstance.getWrappedInstance)) {
                // check to see if this is also wrapped by connect and if so get that instance instead
                // for this to work your connect has to have withRef
                // connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})
                return this._wrappedInstance.getWrappedInstance();
            } else {
                return this._wrappedInstance;
            }
        }

        render() {
            const allProps = {
                setConfigValues: this._setValues,
                monthSelections: this._months,
                yearSelections: this._years,
                rateTypeSelections: this._ratesTypes,
                ...omit(Config, ['set']),
                ...this.props,
            };

            if (this._isStateful) {
                allProps.ref = (node) => {
                    this._wrappedInstance = node;
                };
            }

            return <EnhancedComponent {...allProps} />;
        }
    };
};
